import React, { useState } from 'react';
import { blogList } from '../../../config/data';
import Navbar1 from '../../main/Navbar1';
import Sidebar from '../components/sidebar/Sidebar';
import PostDatatable from '../components/datatable/PostDatatable';

const Posts = () => {
  const [blogs, setBlogs] = useState(blogList);
  const [searchKey, setSearchKey] = useState('');

  // Search submit
  const handleSearchBar = (e) => {
    e.preventDefault();
    handleSearchResults();
  };

  // Search for blog by category
  const handleSearchResults = () => {
    const allBlogs = blogList;
    const filteredBlogs = allBlogs.filter((blog) =>
      blog.category.toLowerCase().includes(searchKey.toLowerCase().trim())
    );
    setBlogs(filteredBlogs);
  };

  return (
    <div className="list">
      <Sidebar/>
      <div className="listContainer">
        <Navbar1/>
        <PostDatatable/>
      </div>
    </div>
  );
};

export default Posts;
